import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

type Props = Readonly<{
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}>;

export const ShowReadingOrderToggle = ({ checked, disabled, onChange }: Props) => {
  const id = "show-reading-order-toggle";
  return (
    <FormGroup check>
      <Label check htmlFor={id}>
        <Input checked={checked} disabled={disabled} id={id} onChange={onChange} type="checkbox" />{" "}
        Show Reading Order
      </Label>
    </FormGroup>
  );
};
ShowReadingOrderToggle.displayName = "ShowReadingOrderToggle";
